// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1328":"ced1f529","2663":"2b11c1bd","3877":"844d1f38","4660":"3eb959c9","6516":"a2e79f89"}[chunkId] + ".chunk.css";
};